import { Pipe, PipeTransform } from '@angular/core';
import { EnumConverter } from '../classes';
import { SAP_PAYMENT_TYPE } from '../enums';

@Pipe({
  name: 'sapPaymentType'
})
export class SapPaymentTypePipe extends EnumConverter implements PipeTransform {
  enumeration = SAP_PAYMENT_TYPE;
}
